<template>
  <FormSection
    :icon="IconColoredCo2"
    :title="capitalize($t('messages.sustainability'))">
    <div class="sustainability-card">
      <div class="sustainability-abstract">
        <img
          style="object-fit: contain; width: 30rem; height: auto"
          src="/assets/images/sustainability/CS_005.png"
          alt="sustainability-abstract" />
      </div>
      <div class="sustainability-actions">
        <h1>{{ capitalize($t('messages.sustainabilityTitle')) }}</h1>
        <div>
          <p>{{ capitalize($t('messages.sustainabilityDescription')) }}</p>
        </div>
        <div class="sustainability-button">
          <p class="font-weight-bold">{{ capitalize($t('actions.enableSustainability')) }}</p>
          <div class="col-sm-8">
            <toggle-button
              class="mt-0"
              :color="Colors.success"
              :value="isTargetingSustainableInventory"
              @change="toggleSustainability" />
          </div>
        </div>
        <div class="powered-by">
          <p>{{ capitalize($t('messages.poweredBy')) }}</p>
          <img
            src="/assets/images/scope3.svg"
            alt="scope-3-logo" />
        </div>
      </div>
    </div>
  </FormSection>
</template>

<script setup lang="ts">
  import { capitalize, computed, Ref } from 'vue';

  import Colors from '@/Colors';
  import FormSection from '@/common/components/controls/FormSection.vue';
  import ToggleButton from '@/common/components/controls/ToggleButton.vue';
  import { IconColoredCo2 } from '@/common/icons/colored';
  import { Package } from '@/common/models';
  import { DEFAULT_SUSTAINABILITY_THRESHOLD } from '@/common/models/package/Package';
  import { useInjected } from '@/globals';
  import { mapActions } from '@/utils/StateMapping';

  const deal: Ref<Package> = useInjected<Package>('deal');

  const isTargetingSustainableInventory = computed(() => {
    return deal.value.co2EmissionsScoreThreshold > 0;
  });

  const { updatePackageCo2EmissionsScoreThreshold } = mapActions();

  function toggleSustainability() {
    const co2EmissionsScoreThreshold = isTargetingSustainableInventory.value ? 0 : DEFAULT_SUSTAINABILITY_THRESHOLD;
    updatePackageCo2EmissionsScoreThreshold({
      package: deal.value,
      value: co2EmissionsScoreThreshold,
    });
  }
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables' as *;

  .sustainability-card {
    display: flex;
  }

  .sustainability-abstract {
    flex: 1;
  }

  .sustainability-abstract > img {
    object-fit: contain;
    width: 30rem;
    height: auto;
  }

  .sustainability-actions {
    flex: 3;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    text-align: left;
    margin: 1.5rem 3rem 0;
  }

  .sustainability-actions > h1 {
    padding: 0 !important;
    box-shadow: none !important;
    font-weight: initial !important;
  }

  .sustainability-button {
    display: flex;
    flex-direction: row;
    justify-content: start;
    gap: 1rem;
  }

  .powered-by {
    display: flex;
    flex-direction: column;
    align-items: end;
  }
</style>
